import styled from "styled-components";
import { Tab } from "@origin-digital/ods-core";

export const StyledTab = styled(Tab)(() => ({
  "&&": {
    " &.mobile-tab": {
      minWidth: "62px",
    },
  },
}));
